import React, { useEffect, useState } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { Modal, Form, Button, Col } from "react-bootstrap";

const UserTypeFilter = (props) => {
  const accountTypeList = [
    {
      account_status: "Real",
      id: 5,
    },
    {
      account_status: "Test",
      id: 6,
    },
  ];
  //value: valueProp,
  const { onClose, open, ...other } = props;
  const [value, setValue] = useState("");

  const handleCancel = () => {
    onClose();
  };

  useEffect(()=>{
    setValue("");
  },[open])
  const handleOk = () => {
    onClose(value);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
      {...other}
    >
      <DialogTitle>User Status</DialogTitle>
      <DialogContent dividers>
        <Form.Group as={Col} controlId="formAccount">
          <Form.Label className="label">User Type</Form.Label>
          <Form.Select name="platform" value={value} onChange={handleChange}>
            <option value="">Select User Type </option>
            {accountTypeList.map((item) => {
              return (
                <option value={item.account_status}>
                  {item.account_status}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          onClick={handleOk}
          //disabled ={value == '' ? true : false}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserTypeFilter;
